import { useContext } from 'react';
import { NotificationContext } from './NotificationsContext';

export const useNotification = () => {
  return useContext(NotificationContext);
};
